import React from "react";
import { Input } from "../../components/ui/input";
// import { FaSearch } from "react-icons/fa";

const SearchInput = ({ value, onChange, placeholder = "Search..." }) => {
  return (
    <div className="relative">
      
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="pl-9 border border-darkgray"
      />
    </div>
  );
};

export default SearchInput;
